import { render, staticRenderFns } from "./LimitEkp.vue?vue&type=template&id=69ab999b"
import script from "./limit-ekp.js?vue&type=script&lang=js&external"
export * from "./limit-ekp.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports